<template>
  <div class="detail-header">
    <div class="header-top">
      <div class="header-info">
        <div class="ship-identity">
          <h1 class="ship-number">{{ detail.shipmentNo || '-' }}</h1>
          <el-tag class="status-tag" size="mini" effect="light">
            {{ detail.shipmentStatusName || '-' }}
          </el-tag>
        </div>
        <div class="ship-meta">
          <span class="meta-item">
            <i class="el-icon-time meta-icon" />
            <span>
              {{ $l('section_created_prefix') || '创建：' }}
              {{ detail.createByName || '-' }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <nav class="tab-nav">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        class="tab-pill"
        :class="{ active: activeTab === tab.value }"
        @click="$emit('changeTab', tab.value)"
      >
        {{ tab.label }}
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: { type: String, default: '' },
    detail: { type: Object, default: () => ({}) },
  },
  computed: {
    tabs() {
      return [
        { label: this.$l('section_base_info') || '基础信息', value: 'base' },
        { label: this.$l('section_goods_list') || '产品清单', value: 'goods' },
        {
          label: this.$l('section_container_record') || '分柜记录',
          value: 'container',
        },
        {
          label: this.$l('section_booking_record') || '订舱记录',
          value: 'booking',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-header {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  padding: 16px 20px 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.header-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.ship-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
}

.ship-number {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  letter-spacing: 0.01em;
  line-height: 1.2;
}

.status-tag {
  height: 20px;
  padding: 0 6px;
  line-height: 18px;
  border-radius: 4px;
  border-color: #dbeafe;
  background: #f5f9ff;
  color: #3b82f6;
  font-weight: 600;
}

.ship-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  font-size: 12px;
  color: #64748b;
  strong {
    color: #334155;
    font-weight: 600;
  }
}

.meta-icon {
  flex-shrink: 0;
  font-size: 12px;
  opacity: 0.72;
}

.meta-divider {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
}

.tab-nav {
  display: flex;
  gap: 6px;
  margin: 0 -6px;
  padding: 2px 0 8px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 0;
  }
}

.tab-pill {
  position: relative;
  padding: 10px 14px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s;
  font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', -apple-system,
    sans-serif;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 10px;
    right: 10px;
    height: 3px;
    border-radius: 1px;
    background: transparent;
    transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
  }
  &:hover {
    color: #334155;
  }
  &.active {
    color: #2563eb;
    &:after {
      background: #409eff;
      left: 8px;
      right: 8px;
    }
  }
}
</style>
